import { information } from './modal-option';
import { tlang } from '../language/lang';

export async function offline() {
  await information(
    tlang`The operation could not be completed due to an issue communicating with the online services`,
    tlang`System Offline`
  );
}
